export const DEFAULT_CURRENCY_SYMBOL = '€'
export const DEFAULT_CURRENCY_CODE = 'EUR'
